import {
  BarChart3,
  Blocks,
  ChevronLeft,
  Compass,
  FileText,
  LayoutDashboard,
  Link2,
  LogOut,
  Menu,
  PanelTop,
  Settings,
  Share2,
  Sparkles,
  Heart,
  X,
} from "lucide-react";
import { useState, type PropsWithChildren } from "react";
import { signOut as signOutFirebase } from "firebase/auth";
import { NavLink, useNavigate } from "react-router-dom";
import { Brand } from "../components/Brand";
import { logout } from "../lib/api";
import { auth } from "../lib/firebase";
import type { AdminUser } from "../types/content";

const navigation = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/landing-page", label: "Landing page", icon: PanelTop },
  { to: "/admin/wedding", label: "Undangan pernikahan", icon: Heart },
  { to: "/admin/products", label: "Products", icon: Blocks },
  { to: "/admin/services", label: "Capabilities", icon: Sparkles },
  { to: "/admin/principles", label: "Principles", icon: Compass },
  { to: "/admin/statistics", label: "Statistics", icon: BarChart3 },
  { to: "/admin/social-links", label: "Social links", icon: Share2 },
  { to: "/admin/navigation", label: "Navigation", icon: Link2 },
  { to: "/admin/settings", label: "Settings & SEO", icon: Settings },
];

export function AdminLayout({ user, children }: PropsWithChildren<{ user: AdminUser }>) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  async function signOut() {
    await logout();
    await signOutFirebase(auth).catch(() => undefined);
    navigate("/admin/login", { replace: true });
  }

  return (
    <div className="admin-shell">
      <aside className={`admin-sidebar ${open ? "is-open" : ""}`}>
        <div className="sidebar-top">
          <Brand />
          <button className="sidebar-close" onClick={() => setOpen(false)}><X size={20} /></button>
        </div>
        <div className="sidebar-label">Content workspace</div>
        <nav>
          {navigation.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? "is-active" : "")}
            >
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-foot">
          <a href="/" target="_blank" rel="noreferrer">
            <FileText size={17} /> View public site <ChevronLeft size={14} className="rotate-link" />
          </a>
          <button onClick={signOut}>
            <LogOut size={17} /> Sign out
          </button>
        </div>
      </aside>
      <div className="admin-workspace">
        <header className="admin-topbar">
          <button className="admin-menu" onClick={() => setOpen(true)} aria-label="Open navigation">
            <Menu size={20} />
          </button>
          <div className="admin-breadcrumb">
            <span>CMS</span>
            <i>/</i>
            <strong>Steria House</strong>
          </div>
          <div className="admin-user">
            <span>{user.name}</span>
            <i>{user.name.slice(0, 1)}</i>
          </div>
        </header>
        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
}
